import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

export default function PricingSection({
  values = {},
  setValues = () => {},
  cin7Product = {},
}) {

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
        Pricing
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1.2fr 1fr 0.8fr 1fr 1fr 1fr",
          gap: 2,
          fontWeight: 600,
          mb: 1,
        }}
      >
        <Typography>Tier</Typography>
        <Typography>Price</Typography>
        <Typography sx={{ textAlign: "center" }}>Calculated</Typography>
        <Typography>Type</Typography>
        <Typography>Use</Typography>
        <Typography>Value</Typography>
      </Box>
      {[
        { tier: 1, label: "B2C Price" },
        { tier: 2, label: "Compare Price" },
        { tier: 3, label: "B2B Price" },
      ].map(({ tier, label }) => {
        const isCalculated = values[`calculated${tier}`];
        return (
          <Box
            key={tier}
            sx={{
              display: "grid",
              gridTemplateColumns: "1.2fr 1fr 0.8fr 1fr 1fr 1fr",
              gap: 2,
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography>{label}</Typography>
            <TextField
              type="number"
              value={values[`price${tier}`]}
              disabled={isCalculated}
              fullWidth
              size="small"
              onChange={(e) => {
                let value = e.target.value;
                if (value.includes(".")) {
                  const [int, dec] = value.split(".");
                  value = int + "." + dec.slice(0, 2);
                }
                setValues((prev) => ({
                  ...prev,
                  [`price${tier}`]: value,
                }));
              }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={!!isCalculated}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setValues((prev) => ({
                      ...prev,
                      [`calculated${tier}`]: checked,
                      ...(checked
                        ? { [`price${tier}`]: 0 }
                        : {
                            [`price${tier}`]: cin7Product[`priceTier${tier}`] ?? 0, // Back to cin7 price when unchecking
                            [`markupType${tier}`]: "",
                            [`usePriceType${tier}`]: "",
                            [`markupValue${tier}`]: "",
                          }),
                    }));
                  }}
                />
              }
              label=""
              sx={{ justifyContent: "center" }}
            />
            <TextField
              select
              disabled={!isCalculated}
              fullWidth
              size="small"
              value={values[`markupType${tier}`]}
              onChange={(e) =>
                setValues((prev) => ({
                  ...prev,
                  [`markupType${tier}`]: e.target.value,
                }))
              }
            >
              <MenuItem value="P">Markup</MenuItem>
              <MenuItem value="A">Append</MenuItem>
            </TextField>
            <TextField
              select
              disabled={!isCalculated}
              fullWidth
              size="small"
              value={values[`usePriceType${tier}`]}
              onChange={(e) =>
                setValues((prev) => ({
                  ...prev,
                  [`usePriceType${tier}`]: e.target.value,
                }))
              }
            >
              <MenuItem value="A">Average cost</MenuItem>
              <MenuItem value="F">Fixed price</MenuItem>
              <MenuItem value="L">Latest price</MenuItem>
              <MenuItem value="V">Price tier value</MenuItem>
            </TextField>
            <TextField
              type="number"
              disabled={!isCalculated}
              fullWidth
              size="small"
              value={values[`markupValue${tier}`]}
              onChange={(e) => {
                let value = e.target.value;
                if (value.includes(".")) {
                  const [int, dec] = value.split(".");
                  value = int + "." + dec.slice(0, 2);
                }
                setValues((prev) => ({
                  ...prev,
                  [`markupValue${tier}`]: value,
                }));
              }}
            />
          </Box>
        );
      })}
      <Box sx={{ mt: 2 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={!!values.continueSelling}
              onChange={(e) =>
                setValues((prev) => ({
                  ...prev,
                  continueSelling: e.target.checked,
                }))
              }
            />
          }
          label="Continue Selling when out of stock"
        />
      </Box>
    </Box>
  );
}
